/**
 * M.3 — Folder export target.
 *
 * Wraps the existing `exportToFolder` function (F7) in the ExportTarget
 * shape. Visible when FSAP readwrite is available (Chrome/Edge).
 */

import {
  exportToFolder,
  isShowDirectoryPickerWritableAvailable,
} from '../toFolder';
import type { ExportTarget } from './types';

export const folderTarget: ExportTarget = {
  id: 'folder',
  label: 'Folder…',
  tooltip: (env) =>
    env.fsapAvailable
      ? 'Pick a folder on your computer'
      : 'Browser does not support folder write — use ZIP instead',
  isVisible: () => true, // always visible; tooltip explains disabled
  isEnabled: (env) => env.fsapAvailable,
  run: async (site) => {
    const result = await exportToFolder(site);
    return {
      summary: `Folder export complete: ${result.filesWritten} notes / flows + ${result.assetsWritten} assets in "${result.folderName}".`,
    };
  },
};

/** Re-export the availability probe for environment construction. */
export { isShowDirectoryPickerWritableAvailable };
